import type { WebsiteHeaderPhotoSchema_PhotoSlider } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_SLIDER_DEFAULT: WebsiteHeaderPhotoSchema_PhotoSlider = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',
  presentationLayout: 'photoSlider',
  photos: [],
};
